@if(home$ | async; as home){
  <view-edit-user-timezone (home)="home" />
}